import { AxiosResponse } from "axios";

export const successfulAction = (resp: AxiosResponse): boolean => {
    return (
        resp?.status === 200 &&
        resp?.data?.requests != null &&
        resp?.data?.succeeded != null &&
        resp?.data?.requests === resp?.data?.succeeded
    );
};